module.exports = __webpack_public_path__ + "media/images/logo-white-6930ae480d66d7b4785553b2f9c56076.png";